import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { Row, Col } from "react-bootstrap";
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import {ListItemIcon, ListItemText, MenuItem, Menu } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  listItemIcon: {
    width: 50,
    justifyContent: "flex-end",
    alignSelf: "flex-start",
    marginTop: 8,
    flexGrow: 0,
    flexShrink: 0,
  },
  svg:{
    marginRight: 10,
    color:`${theme.palette.primary.main}`
  },
  menuItem:{
    paddingLeft: 0,
    paddingRight: 0,
    minWidth:'unset!important',
    maxWidth:'335px!important'
  },
  text:{
    whiteSpace: 'pre-line!important',
  }
}));

export default function SelectInput(props) {
  const classes = useStyles();

  const { errors, selectOptions, id, variant, helpText, inputColumnSize, hideEmptyOption, isImageOptions, ...textFieldProps } = props;
  const columnSize = inputColumnSize || 12;

  const empty = [<option aria-label="None" value="" key={0} />];

  const menuItems = isImageOptions ?
    selectOptions && selectOptions.map((item, i)=>{
      return(
          <MenuItem value={item.value} className={classes.menuItem} key={i}>
          {item.icon &&  <ListItemIcon className={classes.listItemIcon}>
              <item.icon className={classes.svg}/>
            </ListItemIcon>}
            <ListItemText className={classes.text} primary={item.label} secondary={item.secondaryText}/>              
          </MenuItem>
      )
    })
  : selectOptions && selectOptions.map((option, key) => {
    return <option value={option.value} key={key + 1} disabled={option.disabled}>{option.label}</option>
  });

  var allMenuItems;

  if (selectOptions && hideEmptyOption) {
    allMenuItems = menuItems;
  } else if (selectOptions) {
    allMenuItems = empty.concat(menuItems);
  } else {
    allMenuItems = empty;
  }

  return (
    <Row>
      <Col xs={columnSize}>
        <FormControl
          fullWidth
          variant={variant || "filled"}
          error={!!errors}
        >
          <InputLabel htmlFor={id}>{props.label}</InputLabel>
          <Select
            native = {!isImageOptions}
            {...textFieldProps}
            inputProps={{
              id: id,
            }}
          >   
            {allMenuItems}
          </Select>
          <FormHelperText id={`${id}-helper-text`} aria-describedby={`${id}-helper-text`}>{errors && errors.message}</FormHelperText>
        </FormControl>
      </Col>

      {helpText &&
        <Col xs={2}>
          <div className="d-flex mt-2">
            <Tooltip title={helpText}>
              <InfoIcon color="action"></InfoIcon>
            </Tooltip>
          </div>
        </Col>
      }
    </Row>
  )
}

SelectInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
  })).isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  variant: PropTypes.string,
  errors: PropTypes.object,
  hideEmptyOption: PropTypes.bool,
  helpText: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/SelectInput.js